module.exports = __webpack_public_path__ + "img/symmetry_jp.6a6342e.jpg";